/* Copyright 2013 - 2022 Waiterio LLC */
import currencyCode2Symbol from './currencyCode2Symbol.js'

export default function getCurrencySymbol(currencyCode) {

  return currencyCode2Symbol[currencyCode] ? currencyCode2Symbol[currencyCode] : '$'

}
